import Image from 'next/image';
import { useRef, useState } from 'react';
import {
  LANGUAGE_ENUMS,
  domainCode,
} from '../../../constants/staticPageConstants';
import { ButtonVariants } from '../../Atoms/Button';
import { DemoModal } from '../../Atoms/DemoModal';
import { MarktechModal } from '../../Atoms/Modal';
import { CloseIcon } from '../../Icons';
import { useOnClickOutside } from '../../hooks';
import {
  DropdownComponent,
  TDropdownList,
} from '../DynamicHeader/Dropdown/DropdownComponent';
import { HEADER_LABELS } from '../DynamicHeader/Dropdown/DropdownData';
import {
  ABOUT_US,
  CONTACT_US_PAGE,
  SOLUTIONS,
} from '../DynamicHeader/Dropdown/DropdownDataFrCommon';
import { GeneralDropdown } from '../DynamicHeader/Dropdown/DropdownOptionsComponent';
import { LoginButton } from '../LoginButton';
import { getLogoLink } from '../utils';

const myLoader = () => {
  return `https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg`;
};

interface IProps {
  language: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain: number;
}

const DesktopNavBar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: IProps): JSX.Element => {
  const modalRef = useRef(null);
  const header_labels = HEADER_LABELS[language as keyof typeof HEADER_LABELS];

  const direction = language === LANGUAGE_ENUMS.Arabic ? 'rtl' : 'ltr';

  const [displayPopup, demoPopup] = useState(false);

  const leftDropdownsContent = [];

  if (domain == domainCode.cleartaxMY) {
    leftDropdownsContent.push({
      dropdownLabel: header_labels.about_us,
      dropdownList: ABOUT_US[domain],
    });
  } else {
    leftDropdownsContent.push(
      {
        dropdownLabel: header_labels.about_us,
        dropdownList: ABOUT_US[domain],
      },
      {
        dropdownLabel: header_labels.solutions,
        dropdownList: SOLUTIONS[domain],
      }
    );
  }
  const commonAttributes = {
    domain: 'sa',
    language: language,
    classes: 'relative',
    hover: true,
    Dropdown: GeneralDropdown,
  };

  useOnClickOutside(modalRef, () => {
    demoPopup(false);
  });

  return (
    <>
      <div
        className="bg-white p-3 w-full fixed top-0 z-20 font-medium sm:px-0"
        style={{ direction: direction }}
        data-testid="Header"
      >
        <nav className="flex  items-start text-s-14 z-20 md:w-full sm:w-full font-medium wg-container gap-1">
          <div
            className={`sm:w-full items-end bg-white inline-flex flex-grow w-auto z-50 sm:flex-row sm:shadow-sm`}
          >
            <a
              href={getLogoLink(domain, language)}
              className="inline-flex items-center p-2"
            >
              <Image
                loader={myLoader}
                src="me.png"
                alt="Picture of the author"
                width={153}
                height={27}
              />
            </a>
            {leftDropdownsContent.map((dropdownProps) => (
              <div key={dropdownProps.dropdownLabel}>
                <DropdownComponent {...dropdownProps} {...commonAttributes} />
              </div>
            ))}
            <button
              type="button"
              className="font-medium flex w-auto py-2 rounded text-font-500 whitespace-nowrap mr-3"
              aria-expanded="true"
              aria-haspopup="true"
            >
              <a
                href={CONTACT_US_PAGE[domain]}
                rel="noreferrer"
                className="sm:text-s-12 text-font-500"
              >
                {header_labels.contact_us}
              </a>
            </button>
          </div>
          <div
            className={`sm:w-full bg-white inline-flex flex-grow w-auto z-50 flex-row-reverse sm:flex-row sm:shadow-sm`}
          >
            <div className="flex items-center">
              <div className="relative w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto items-center flex sm:flex-col lg:h-auto xl:h-auto">
                <DropdownComponent
                  dropdownLabel={header_labels.language}
                  dropdownList={LangSwitchLink as TDropdownList}
                  {...commonAttributes}
                />
                <div className="w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto  lg:items-center items-start  flex sm:flex-col lg:h-auto xl:h-auto">
                  {domain == domainCode.cleartaxMY ? (
                    <></>
                  ) : (
                    <div>
                      <LoginButton
                        buttonColor={ButtonVariants.greyfilled}
                        language={language}
                        link="https://accounts.cleartax.com/v2?product=einvoice&return_path=L21pZGRsZS1lYXN0L2tzYS9laW52b2ljaW5nLw=="
                      />
                    </div>
                  )}
                  <div
                    className="sm:px-0 sm:py-2 whitespace-nowrap cursor-pointer "
                    onClick={() => demoPopup(true)}
                  >
                    <span className="button button-bluefilled font-bold inline-flex items-center lg:w-auto rounded-lg text-base w-full whitespace-nowrap">
                      {header_labels.demo}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="h-20"></div>
      <MarktechModal
        open={displayPopup}
        onClose={() => {}}
        classNames={{
          modal:
            'md:w-11/12 sm:w-11/12 w-1/2 w-1/2 mobile-search-box rounded-2xl',
        }}
        closeIcon={<CloseIcon />}
        center
      >
        <DemoModal
          modalRef={modalRef}
          demoPopup={demoPopup}
          language={language}
          domain={domain}
        />
      </MarktechModal>
    </>
  );
};

export { DesktopNavBar };
